import React from "react";
import PropTypes from "prop-types";
import Expandable from "components/shared/Expandable";
import GroupsInfoFaqRow from "components/groups/info/GroupsInfoFaqRow";

export default function GroupsInfoExpandableFaqRow({ question, answer }) {
  return (
    <Expandable expandableClassName="groups-info__expandable-row">
      <GroupsInfoFaqRow question={question} answer={answer} />
    </Expandable>
  );
}
GroupsInfoExpandableFaqRow.propTypes = {
  answer: PropTypes.node,
  question: PropTypes.string
};
